import { ENDPOINT } from '@old/data/core/endpoints';
import { BACKEND } from '@old/services/core/fetch-backend';
import { transformIntoQueryParamString } from '@old/utils/service';

import {
  SearchExtractionPredictivePayload,
  SearchExtractionPredictiveResponse,
} from './silobag-extraction-predictive.types';

export async function searchExtractionFieldsService({ query: search }: SearchExtractionPredictivePayload) {
  const { field, text } = search;
  const query = transformIntoQueryParamString(field, text);

  const { response, data } = await BACKEND.get<SearchExtractionPredictiveResponse>(
    ENDPOINT.SILOBAG_EXTRACTION_PREDICTIVE,
    {
      query,
    }
  );

  return {
    response,
    summary: data,
  };
}
